import { render, staticRenderFns } from "./TransfersResume.vue?vue&type=template&id=cd556dde&scoped=true"
import script from "./TransfersResume.vue?vue&type=script&lang=js"
export * from "./TransfersResume.vue?vue&type=script&lang=js"
import style0 from "./TransfersResume.vue?vue&type=style&index=0&id=cd556dde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd556dde",
  null
  
)

export default component.exports